import { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const ADMIN_SESSION_EXPIRED_MSG = 'Your admin session expired or was signed out. Please log in again.';

// Validates the stored admin token on mount and signs out cleanly on any admin 401
export const useAdminSessionGuard = (onExpired) => {
  const fired = useRef(false);
  const cb = useRef(onExpired);
  cb.current = onExpired;

  useEffect(() => {
    const expire = () => {
      if (fired.current) return;
      fired.current = true;
      localStorage.removeItem('admin_token');
      delete axios.defaults.headers.common['Authorization'];
      // let the failing panels' own error toasts land, then replace them with one clear message
      setTimeout(() => { toast.dismiss(); cb.current(ADMIN_SESSION_EXPIRED_MSG); }, 500);
    };
    const id = axios.interceptors.response.use((r) => {
      if ((r.config?.url || '').includes('/api/admin')) fired.current = false;
      return r;
    }, (err) => {
      const url = err.config?.url || '';
      if (err.response?.status === 401 && url.includes('/api/admin') && !url.includes('/admin/login')) expire();
      return Promise.reject(err);
    });
    const token = localStorage.getItem('admin_token');
    if (token) {
      axios.get(`${API}/api/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
        .catch((e) => { if ([401, 403].includes(e.response?.status)) expire(); });
    }
    return () => axios.interceptors.response.eject(id);
  }, []);
};
